// extracted by mini-css-extract-plugin
export default {"container":"kea-z","innerContainer":"lea-z","multipleLines":"mea-z","heading":"nea-z","content":"oea-z","linkColor":"pea-z"};